import {
  Box,
  FormHelperText,
  MenuItem,
  Select,
} from '@mui/material';
import useStyles from './styles';

export default function SelectInput({
  error,
  children,
  placeholder,
  helperText,
  FormHelperTextProps,
  ...props
}) {
  const classes = useStyles({ error });

  return (
    <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <Select
        variant="standard"
        className={classes.selectOptions}
        classes={{ select: classes.selected }}
        inputProps={{
          classes: { icon: classes.icon },
        }}
        displayEmpty={!!placeholder}
        renderValue={placeholder ? (selected) => {
          if (!selected) {
            return <span style={{ color: '#aaa' }}>{placeholder}</span>;
          }
          return selected;
        } : undefined}
        {...props}
      >
        {placeholder && (
          <MenuItem disabled value="">
            {placeholder}
          </MenuItem>
        )}
        {children}
      </Select>

      {helperText && (
        <FormHelperText error={!!error} {...FormHelperTextProps}>
          {helperText}
        </FormHelperText>
      )}
    </Box>
  );
}
